import React from "react";
import { Container, Card, Row, Col, Button } from "react-bootstrap";
import TermsModal from "./TermsModal";

export default function LeadForm() {
  const [showTerms, setShowTerms] = React.useState(false);

  const whatsappMessage = encodeURIComponent(
    "Hola Sanus Esthetic, estoy interesado(a) en conocer más sobre sus servicios."
  );

  const whatsappURL = `https://wa.me/573153163451?text=${whatsappMessage}`;

  return (
    <Container className="my-5" id="Leadform">
      <Row className="g-4 align-items-stretch">
        <Col md={6}>
          <Card className="p-4 shadow h-100 text-center">
            <h3 className="text-info mb-4">¿Tienes preguntas?</h3>
            <p className="text-muted">
              Si deseas información sobre nuestros tratamientos, horarios o
              disponibilidad, no dudes en escribirnos. ¡Estamos para ayudarte!
            </p>
            <Button
              variant="success"
              size="lg"
              href={whatsappURL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3"
            >
              Contáctanos por WhatsApp
            </Button>
            <div className="mt-3">
              <span
                className="text-primary"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => setShowTerms(true)}
              >
                Ver términos y condiciones
              </span>
            </div>
          </Card>
        </Col>

        <Col md={6}>
          <div className="h-100 shadow rounded overflow-hidden">
            <iframe
              title="Ubicación Sanus Esthetic"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.4421414461385!2d-74.05096952652796!3d4.692977941727583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9ab970769d07%3A0xe0ba974c3e48bacd!2sCra.%2017a%20%23106A%20-52%2C%20Bogot%C3%A1!5e0!3m2!1ses!2sco!4v1750483947010!5m2!1ses!2sco"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "400px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </Col>
      </Row>

      <TermsModal show={showTerms} onHide={() => setShowTerms(false)} />
    </Container>
  );
}
